import { Menu, menuClasses } from 'react-pro-sidebar';
import React, { ReactNode } from 'react';

const SidebarMenu = ({ children }: { children: ReactNode }) => {
  return (
    <Menu
      rootStyles={{
        ['.' + menuClasses.button]: {
          height: 'auto',
          padding: '8px 20px',
          '&:hover': {
            backgroundColor: '#03829a4f',
          },
        },
      }}
    >
      {children}
    </Menu>
  );
};

export default SidebarMenu;
